import React,{useEffect,useMemo,useState} from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiAlertTriangle,FiCheckCircle,FiClock,FiMapPin}=FiIcons;

const logisticsFields=[
  ['loadInInstructions','Load-in instructions'],
  ['venueContact','Venue contact'],
  ['setupAccessTime','Setup access time'],
  ['parkingAccess','Parking and vendor access'],
  ['powerAccess','Power access'],
  ['venueRestrictions','Venue restrictions'],
  ['insuranceRequirements','Insurance requirements']
];

function readLogisticsAnswers() {
  try {
    const answers=JSON.parse(
      localStorage.getItem('amp-planner-answers') || '{}'
    );

    return answers || {};
  } catch {
    return {};
  }
}

function VenueLogisticsAlerts({event}) {
  const [answers,setAnswers]=useState(readLogisticsAnswers);

  useEffect(()=> {
    const refreshAnswers=()=> setAnswers(readLogisticsAnswers());

    window.addEventListener('focus',refreshAnswers);
    document.addEventListener('visibilitychange',refreshAnswers);

    return ()=> {
      window.removeEventListener('focus',refreshAnswers);
      document.removeEventListener('visibilitychange',refreshAnswers);
    };
  },[]);

  const alerts=useMemo(
    ()=> logisticsFields
      .filter(([id])=> !String(answers[id] || '').trim())
      .map(([id,label])=> ({id,label})),
    [answers]
  );

  const completedCount=logisticsFields.length-alerts.length;
  const isComplete=alerts.length===0;

  return (
    <section
      className={`panel venue-alerts ${isComplete ? 'complete' : ''}`}
      aria-labelledby="venue-alerts-title"
    >
      <div className="venue-alerts-heading">
        <div className="venue-alerts-icon">
          <SafeIcon icon={isComplete ? FiCheckCircle : FiAlertTriangle} />
        </div>
        <div>
          <span className="eyebrow">Production readiness</span>
          <h2 id="venue-alerts-title">Venue logistics alerts</h2>
          <p>
            {isComplete
              ? 'All venue logistics details have been provided.'
              : `${alerts.length} venue detail${alerts.length===1 ? '' : 's'} still need attention before event day.`}
          </p>
        </div>
        <span className="venue-alerts-count">
          {completedCount}/{logisticsFields.length} complete
        </span>
      </div>

      {isComplete ? (
        <div className="venue-alert-success">
          <SafeIcon icon={FiCheckCircle} />
          <span>
            <strong>Venue information is ready</strong>
            The production team has the details needed for load-in and setup.
          </span>
        </div>
      ) : (
        <div className="venue-alert-list">
          {alerts.map((alert)=> (
            <div className="venue-alert-item" key={alert.id}>
              <SafeIcon icon={FiClock} />
              <span>
                <strong>{alert.label}</strong>
                <small>Missing from the client planner</small>
              </span>
              <SafeIcon icon={FiMapPin} className="venue-alert-location" />
            </div>
          ))}
        </div>
      )}

      {!event?.venue && (
        <p className="venue-alert-note">
          <SafeIcon icon={FiAlertTriangle} />
          Add the event venue details before final production planning.
        </p>
      )}
    </section>
  );
}

export default VenueLogisticsAlerts;